import { useMemo, useEffect } from 'react';
import moment from 'moment';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import {
  // 时间筛选器的key
  RANGE_TIME as FILTER_RANGE_TIME,
  // 组合下拉筛选器的key
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
  // 级联国家筛选器
  // REGION as FILTER_REGION,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getIsSteamTopSellers } from '../../../utils';
import { PC_PLATFORM_STEAM, PC_TOP_TOP_SELLERS } from '@/pages/intelligence/_config/storeRank/config';

import type { IStoreRankDetailsFilter } from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/StoreRank/types';

export default function useUpdateFiltersFormValue(props: {
  filter: IStoreRankDetailsFilter;
  formValue: React.RefObject<any>;
}) {
  const { filter, formValue } = props ?? {};

  const isSteamTopSellers = useMemo(() => {
    const platform = filter?.platform ?? PC_PLATFORM_STEAM;
    const top = filter?.top ?? PC_TOP_TOP_SELLERS;
    return getIsSteamTopSellers({ platform, top });
  }, [filter?.platform, filter?.top]);

  // 更新时间筛选器的value
  useEffect(() => {
    const dateType = !isSteamTopSellers ? 'date' : feachTimeTypeToFilterTimeType(filter?.granularity) ?? 'date';
    const dateValue = [moment(filter?.start_date), moment(filter?.end_date)];
    formValue.current[FILTER_RANGE_TIME] = {
      type: dateType,
      value: dateValue,
    };
  }, [isSteamTopSellers, filter?.granularity, filter?.start_date, filter?.end_date]);

  // 更新platform-top 筛选器的value
  useEffect(() => {
    formValue.current[FILTER_COMPOSED_SELECT] = {
      value: {
        parent: filter?.platform ?? PC_PLATFORM_STEAM,
        child: filter?.top ?? PC_TOP_TOP_SELLERS,
      },
    };
  }, [filter?.platform, filter?.top]);

  // 更新级联国家筛选器的value
  // 这里不用重置级联国家筛选器 勾选国家为global了，在接口调用处，做了非steam top sellers榜单 国家入参固定为global的处理逻辑，这里不重置，就可以实现保留上一次勾选国家的功能
  // useEffect(() => {
  //   if (isSteamTopSellers) return;
  //   formValue.current[FILTER_REGION] = {
  //     type: 'market',
  //     regions: [],
  //     markets: ['global'],
  //   };
  // }, [isSteamTopSellers]);
}
